export default {
  combine: {
    view_report: "@:ui.view Report",
    add_login: "@:ui.add Login",
    add_function: "@:ui.add Function",
    add_page: "@:ui.add Page",
    add_role: "@:ui.add Role",
    add_user: "@:ui.add User",
    edit_login: "@:ui.edit Login",
    edit_function: "@:ui.edit Function",
    edit_page: "@:ui.edit Page",
    edit_role: "@:ui.edit Role",
    edit_user: "@:ui.edit User",
    edit_password: "@:ui.edit @:ui.password",
    delete_login: "@:ui.delete Login",
    delete_function: "@:ui.delete Function",
    delete_page: "@:ui.delete Page",
    delete_role: "@:ui.delete Role",
    delete_user: "@:ui.delete User",
    assign_functions: "@:ui.assign Functions",
    assign_roles: "@:ui.assign Roles",
    confirm_password: "Confirm @:ui.password",
    change_password: "Change @:ui.password",
    old_password: "Old @:ui.password",
    new_password: "@:ui.new @:ui.password",
    account_status: "@:ui.account @:ui.status",
    account_settings: "@:ui.account @:ui.settings",
    layout_settings: "@:ui.layout @:ui.settings",
    confirm_security_code: "Confirm @:ui.security_code",
    first_time_login : "First Time Login",
    security_authentication: "Security Authentication",
    update_security: "Update Security",
    disable_security: "Disable Security",
    add_operator: "Add Operator",
    add_sub_account: "Add Sub Account",
    edit_operator: "Edit Operator",
    edit_member: "Edit Member",
    approve_ticket: "Approve Ticket",
    reject_ticket: "Reject Ticket",
    add_bank_account: "Add Bank Account",
    edit_bank_account: "Edit Bank Account",
    reset_threshold: "Reset Threshold",
    adjust_balance: "Adjust Balance",
    adjust_bank: "Adjust Bank",
    adjust_member: "Adjust Member",
    configure_bank_setting: "Configure Bank Setting",
    account_setup: "Account Setup",
    bank_transfer: "Bank Transfer",
    ticket_audit: "Ticket Audit",
    edit_bank_member: "Edit Bank Member",
    edit_ibank_account: "Edit iBank Account",
    edit_sub_account: "Edit Sub Account",
    view_member: "View Member",
    view_ticket: "View Ticket",
    edit_ticket: "Edit Ticket",
    view_bank_account: "View Bank Account",
    view_bank_member: "View Bank Member",
    view_ibank: "View iBank",
    edit_ibank: "Edit iBank",
    download_package: "Download Package",
    view_package: "View Package",
    edit_package: "Edit Package",
    view_vip: "View VIP",
    edit_vip: "Edit VIP",
    report: "Report",
    knock_off_promo: "Knock Off Promotion",
    add_member_promo: "Add Member Promotion",
    issue_bonus: "Issue Bonus",
    promo_package_download: "Promotion Package Download",
    edit_authority: "Edit Authority",
    reset_password: "Reset Password",
    update_password: "Update Password",
    member_summary: "Member Summary",
    reset_password: "Reset Password",
    issue_livestream_bonus: "Issue Livestream Bonus",
    member_reward: "Member Reward",
    reply_review: "Reply Review",
    edit_affiliate: "Edit Affiliate",
    edit_bank_affiliate: "Edit Bank Affiliate",
    approve_affiliate_ticket: "Approve Affiliate Ticket",
    check_free_spin: "Check Free Spin",
    reject_affiliate_ticket: "Reject Affiliate Ticket",
    wallet_adjust: "Wallet Adjust",
    update_comm_package: "Update Comm Package",
    approve_affiliate: "Approve Affiliate",
    sub_acc_detail_affiliate: "Sub Account Detail Affiliate",
    get_tac: "Get TAC",
    add_coupon: "Add Coupon",
    update_coupon: "Update Coupon",
    issue_free_spin: "Issue Free Spin",
    get_bank_tac: "Get Bank TAC",
    issue_jackpot_scratch: "Issue Jackpot Scratch",
    issue_angpao: "Issue Angpao",
    update_global_setting: "Update Global Setting",
    add_platform: "Add Platform",
    edit_platform: "Edit Platform",
    add_bank_group: "Add Bank Group",
    edit_bank_group: "Edit Bank Group",
    update_maintenance_schedule: "Update Maintenance Schedule",
    add_withdrawal_limit: "Add Withdrawal Limit",
    edit_withdrawal_limit: "Edit Withdrawal Limit",
    add_campaign: "Add Campaign",
    edit_campaign: "Edit Campaign",
    add_promo_group: "Add Promotion Group",
    edit_promo_group: "Edit Promotion Group",
    reapprove_ticket: "Reapprove Ticket",
    edit_vip_provider: "Edit Vip Provider",
    update_team: "Update Team",
    update_result: "Update Result",
    insert_result: "Insert Result",
    bet_list: "Bet List",
    result_list: "Result List",
    add_promo: "Add Promotion",
    raise_deposit_ticket: "Raise Deposit Ticket",
    bank_adjust: "Bank Adjust",
    promo_member_assign: "Promotion Member Assign",
    bonus_issue: "Bonus Issue",
    update_vip: "Update VIP",
    update_member_profile: "Update Member Profile",
    change_withdrawal_limit: "Change Withdrawal Limit",
    change_bank_group: "Change Bank Group",
    change_promotion_group: "Change Promotion Group",
    promotion_signup: "Promotion Signup",
    edit_promo_signup: "Edit Promotion Signup",
    update_provider_bet_limit: "Update Provider Bet Limit",
    update_bet_limit: "Update Bet Limit",
    update_member_bet_limit: "Update Member Bet Limit",
    edit_bank_group: "Edit Bank Group",
    edit_bank_account_group: "Edit Bank Account Group",
    redeposit_ticket: "Redeposit Ticket",
    edit_promotion_group_norm: "Edit Promotion Grorup Norm",
    get_inbox_list: "Get Inbox List",
    view_result_changes_detail: "View Result Changes Detail",
    edit_promotion_signup: "Edit Promotion Signup",
    edit_bet_limit: "Edit Bet Limit",
    edit_provider_game_off: "Edit Provider Game Off",
    edit_provider_rtp: "Edit Provider RTP",
    get_rebate: "Get Rebate",
    get_recent_deposit: "Get Recent Deposit",
    add_survey: "Add Survey",
    clear_outstanding: "Clear Outstanding",
    edit_promotion_group_norm_seq: "Manage Promotion Sequence In Group",
    edit_campaign_provider_list: "Edit Campaign Provider List",
    mini_game_token_issue: "Mini Game Token Issue",
    member_details: "Member Details",
    view_freespin_log_detail: "View Freespin Log Detail",
    edit_exchange_rate: "Edit Exchange Rate",
    log_repulling: "Log Repulling",
    add_banner: "Add Banner",
    add_announcement_banner: "Add Announcement Banner",
    edit_announcement_banner: "Edit Announcement Banner",
    move_announcement_banner: "Move Announcement Banner",
    add_promotion_banner: "Add Promotion Banner",
    edit_promotion_banner: "Edit Promotion Banner",
    move_promotion_banner: "Move Promotion Banner",
    add_slide_banner: "Add Slide Banner",
    edit_slide_banner: "Edit Slide Banner",
    move_slide_banner: "Move Slide Banner",
    add_seo_page: "Add SEO Page",
    edit_seo_page: "Edit SEO Page",
    move_seo_page: "Move SEO Page",
    add_news: "Add News",
    edit_news: "Edit News",
    move_news: "Move News",
    submit_pg: "Submit Payment Gateway",
    reject_withdrawal_ticket_pg: "Reject Withdrawal Ticket (Payment Gateway)",
    approve_withdrawal_ticket_pg: "Approve Withdrawal Ticket (Payment Gateway)",
    resubmit_withdrawal_ticket: "Resubmit Withdrawal Ticket",
    ticket_detail_auto_withdrawal: "Ticket Detail (Auto Withdrawal)"
  },
  authority: {
    account: "Account",
    ticket: "Ticket",
    bank: "Bank",
    promotion: "Promotion",
    vip: "VIP",
    vopr: "View Operator",
    eopr: "Edit Operator",
    vmb: "View Member",
    vtix: "View Ticket",
    etix: "Edit Ticket",
    vbkacc: "View Bank Account",
    ebkacc: "Edit Bank Account",
    vbkmb: "View Bank Member",
    ebkmb: "Edit Bank Member",
    vibk: "View iBank",
    eibk: "Edit iBank",
    dlpck: "Download Package",
    vpck: "View Package",
    epck: "Edit Package",
    vvip: "View VIP",
    evip: "Edit VIP",
    log: "Log",
    rpt: "Report",
    affiliate: "Affiliate",
    setup: "Setup",
    providerwinlose: "Provider Winlose",
    export_excel: "Export Excel",
    cms: "CMS",
  },
  short: {
    provider_status: "P.Status",
    own_status: "O.Status",
    deposit_amount: "Dep Amt",
    base_amount: "Base Amt",
    bonus_amount: "Bonus Amt",
    target_amount: "Trgt Amt",
    accumulate_win: "Acc Win",
    accumulate_turnover: "Acc TO",
    accumulate_amount: "Acc Amt",
    knockoff_by: "K.O By",
    knockoff_date: "K.O Date",
    incoming_amount_threshold: "INC AMT TH",
    accumulate_incoming_amount: "ACCUM INC AMT",
    incoming_frequency_threshold: "INC AMT FRQ",
    accumulate_incoming_frequency: "ACCUM INC FRQ",
    outgoing_amount_threshold: "OG AMT TH",
    accumulate_outgoing_amount: "ACCUM OG AMT",
    outgoing_frequency_threshold: "OG AMT FRQ",
    accumulate_outgoing_frequency: "ACCUM OG FRQ",
    incoming_threshold: "IN THRES",
    incoming_frequency: "IN FREQ",
    outgoing_threshold: "OUT THRES",
    outgoing_frequency: "OUT FREQ",
    account_balance: "ACC BAL",
    promotion_id: "P.ID",
    promotion_name: "P.Name",
    claim_type: "C.Type",
    min_deposit: "M.Deposit",
    bonus_rate: "B.Rate",
    max_bonus: "M.Bonus",
    rollover: "Rollover",
    criteria: "Criteria",
    withhold_bonus: "W.Bonus",
    withhold_amount: "W.Amt",
    max_withdraw_amount: "M.W.Amt",
    start_date: "S.Date",
    end_date: "E.Date",
    start_time: "S.Time",
    end_time: "E.Time",
    monday: "MON",
    tuesday: "TUE",
    wednesday: "WED",
    thursday: "THU",
    friday: "FRI",
    saturday: "SAT",
    sunday: "SUN",
    status: "Status",
    bonus_rate_percent: "B.Rate (%)",
    referee_count_confirm: "R.C.C",
    provider_list: "P.List",
    valid_turnover: "V.Turnover",
    deposit_amount: "Dep Amt",
    deposit_count: "Dep Cnt",
    withdrawal_amount: "Wdw Amt",
    withdrawal_count: "Wdw Cnt",
    bonus_amount: "Bonus Amt",
    adjustment_amount: "Adj Amt",
    referee_count: "Referee Cnt",
    signup_count: "Signup Cnt",
    verified_count: "VRF Count",
    active_member: "Active Mbm",
    ftd_count: "FTD Cnt",
    ftd_amount: "FTD Amt",
    working_date: "Wrking DT",
    bet_count: "Bet Cnt",
    knockoff_reason: "K.O Reason",
    rejected_ticket_id: "R.Ticket Id"
  },
  ok: "OK",
  cancel: "Cancel",
  apply: "Apply",
  login: "Login",
  logout: "Logout",
  home: "Home",
  away: "Away",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  refresh: "Refresh",
  assign: "Assign",
  action: "Action",
  id: "ID",
  name: "Name",
  all: "All",
  search: "Search",
  remove: "Remove",
  save: "Save",
  load: "Load",
  account: "Account",
  settings: "Settings",
  on: "ON",
  off: "OFF",
  new: "New",
  clear: "Clear",
  system: "System",
  functions: "Function | Functions",
  pages: "Page | Pages",
  roles: "Role | Roles",
  users: "User | Users",
  username: "Username",
  password: "Password",
  created_on: "Create On",
  active: "Active",
  disabled: "Disabled",
  blocked: "Blocked",
  suspended: "Suspended",
  page_size: "Page Size",
  no_data: "No Data Available",
  status: "Status",
  login_attempt: "Login Attempt",
  user_roles: "Roles",
  layout: "Layout",
  mustang: "EpicMas Back Office",
  fullname: "Full Name",
  view: "View",
  moreinfo: "More Info",
  result: "Result",
  success: "Success",
  version: "Version",
  ipaddress: "IP Address",
  close: "Close",
  back: "Back",
  show: "Show",
  list: "List",
  login_id: "Login ID",
  login_name: "Login Name",
  filter: "Filter",
  ascending: "Ascending",
  descending: "Descending",
  logs: "Log | Logs",
  action_log: "Action Log",
  date_time: "DateTime",
  status_desc: "Status Desc",
  ip_address: "Ip Address",
  domain_name: "Domain Name",
  browser_agent: "Browser Agent",
  action_by: "Action By",
  target_id: "Target ID",
  target_action: "Target Action",
  details: "Details",
  key: "Key | Keys",
  value: "Value | Values",
  sort: "Sort",
  next: "Next",
  from: "From",
  to: "To",
  type: "Type",
  criteria: "Criteria",
  search_input: "Search Input",
  log: "Log",
  detail_id: "Detail Id",
  action_name: "Action Name",
  reports: "Report | Reports",
  report: "Report",
  sample_rpt: "Sample Report",
  security_tag: "Security Tag",
  security_code: "Security Code",
  submit: "Submit",
  disable: "Disable",
  operators: "Operator | Operators",
  members: "Member | Members",
  account_id: "Account ID",
  parent_id: "Parent ID",
  confirm_password: "Confirm Password",
  self_operate: "Self Operate",
  vip_mode: "VIP Mode",
  full_name: "Full Name",
  contact_phone: "Contact Phone",
  contact_email: "Contact Email",
  dashboard: "Dashboard",
  sub_account: "Sub Account",
  subaccount: "Sub Account",
  authority_option: "Authority Option",
  tickets: "Ticket | Tickets",
  banks: "Bank | Banks",
  vip_level: "Vip Level",
  login_ip : "Login Ip",
  block: "Block",
  profile_id: "Profile ID",
  suspend: "Suspend",
  dob: "DOB",
  mail_address: "Mail Address",
  deposit: "Deposit",
  withdrawal: "Withdrawal",
  rejected: "Rejected",
  processed: "Processed",
  pending: "Pending",
  member: "Member",
  amount: "Amount",
  bank_acc_no: "Bank Acc No.",
  deposit_date: "Deposit Date",
  deposit_method: "Deposit Method",
  approve: "Approve",
  reject: "Reject",
  remark: "Remark",
  ticket_detail: "Ticket Detail",
  promo: "Promo",
  package: "Package",
  created_date: "Created Date",
  currency: "Currency",
  bank_acc_holder: "Bank Acc Holder",
  ref_no: "Ref No.",
  vip: "VIP",
  vip_criteria: "VIP Criteria",
  requirement: "Requirement",
  level_1: "Level 1",
  level_1_name: "Level 1 Name",
  level_1_requirement: "Level 1 Requirement",
  level_1_multp: "Level 1 Multiplier",
  level_2: "Level 2",
  level_2_name: "Level 2 Name",
  level_2_requirement: "Level 2 Requirement",
  level_2_multp: "Level 2 Multiplier",
  level_3: "Level 3",
  level_3_name: "Level 3 Name",
  level_3_requirement: "Level 3 Requirement",
  level_3_multp: "Level 3 Multiplier",
  level_4: "Level 4",
  level_4_name: "Level 4 Name",
  level_4_requirement: "Level 4 Requirement",
  level_4_multp: "Level 4 Multiplier",
  level_5: "Level 5",
  level_5_name: "Level 5 Name",
  level_5_requirement: "Level 5 Requirement",
  level_5_multp: "Level 5 Multiplier",
  level_6: "Level 6",
  level_6_name: "Level 6 Name",
  level_6_requirement: "Level 6 Requirement",
  level_6_multp: "Level 6 Multiplier",
  level_7: "Level 7",
  level_7_name: "Level 7 Name",
  level_7_requirement: "Level 7 Requirement",
  level_7_multp: "Level 7 Multiplier",
  modified_date: "Modified Date",
  modified_by: "Modified By",
  bank_member: "Bank Member",
  bank_operator: "Bank Operator",
  bank_name: "Bank Name",
  bank_acc_type: "Bank Acc Type",
  login_user: "Login User",
  login_pwd: "Login Password",
  account_balance: "Account Balance",
  threshold: "Threshold",
  incoming: "Incoming",
  outgoing: "Outgoing",
  frequency: "Frequency",
  reset_threshold: "Reset Threshold",
  adjust_balance: "Adjust Balance",
  banking_mode: "Banking Mode",
  min_deposit: "Minimum Deposit",
  min_withdrawal: "Minimum Withdrawal",
  bank_from: "Bank From",
  bank_to: "Bank To",
  attachment: "Attachment",
  sender_bank: "Sender Bank",
  sender_bank_acc_no: "Sender Bank Acc No.",
  sender_bank_acc_holder: "Sender Bank Acc Holder",
  audit: "Audit",
  log_id: "Log ID",
  action_status: "Action Status",
  action_date: "Action Date",
  promotion: "Promotion",
  promotion_package: "Promotion Package",
  promotion_account: "Promotion Account",
  promo_id: "Promo ID",
  promo_name: "Promo Name",
  promo_desc: "Promo Description",
  packages: "Package | Packages",
  package_id: "Package ID",
  package_name: "Package Name",
  claim_type: "Claim Type",
  bonus_rate: "Bonus Rate",
  max_bonus: "Max Bonus",
  rollover: "Rollover",
  start_date: "Start Date",
  end_date: "End Date",
  provider_status: "Provider Status",
  own_status: "Own Status",
  package_own_status: "Package Own Status",
  ibank: "iBank",
  ibank_account: "iBank Account",
  ibank_acc_status: "iBank Account Status",
  download: "Download",
  min_balance: "Minimum Balance",
  parent: "Parent",
  adj_amount: "Adjust Amount",
  promotion_member: "Promotion Member",
  on_going: "On Going",
  knock_off: "Knock Off",
  deposit_amount: "Deposit Amount",
  base_amount: "Base Amount",
  bonus_amount: "Bonus Amount",
  bonus_id: "Bonus ID",
  target_amount: "Target Amount",
  claim_date: "Claim Date",
  accumulate_win: "Accumulate Win",
  accumulate_turnover: "Accumulate Turnover",
  knockoff_by: "Knock Off By",
  knockoff_date: "Knock Off Date",
  promo: "Promo",
  package: "Package",
  bonus: "Bonus",
  member_log: "Member Log",
  bonus_log: "Bonus Log",
  transfer_log: "Transfer Log",
  member_id: "Member ID",
  before_balance: "Before Balance",
  transfer_amount: "Transfer Amount",
  after_balance: "After Balance",
  created_by: "Created By",
  bonus_name: "Bonus Name",
  bonus_desc: "Bonus Description",
  bonus_type: "Bonus Type",
  add_promo: "Add Promotion",
  bonus_value: "Bonus Value",
  attach_promo: "Attach Promotion",
  issue_bonus: "Issue Bonus",
  daily_statement: "Daily Statement",
  working_date: "Working Date",
  opening_balance: "Opening Balance",
  turnover: "Turnover",
  valid_turnover: "Valid Turnover",
  winlose: "WinLose",
  withdrawal_amount: "Withdrawal Amount",
  closing_balance: "Closing Balance",
  sub_total: "Sub Total",
  grand_total: "Grand Total",
  daily_winlose: "Daily Winlose",
  game_result_slots: "Game Result (Slots)",
  game_result_livecasino: "Game Result (Livecasino)",
  game_result_rebate: "Game Result (Rebate)",
  game_result_sportsbook: "Game Result (Sportsbook)",
  game_result: "Game Result",
  bet_count: "Bet Count",
  result_id: "Result ID",
  bet_time: "Bet Time",
  payout: "Payout",
  game_type: "Game Type",
  game_name: "Game Name",
  game_provider: "Game Provider",
  loyalty_point_multp: "Loyalty Point Multiplier",
  vip_detail: "VIP Detail",
  reset: "Reset",
  mode: "Mode",
  balance: "Balance",
  min_bal_knock_off_promo: "Min Bal. (To auto knock off promotion)",
  social_account: "Social Account",
  wechat: "Wechat",
  skype: "Skype",
  line: "Line",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  tiktok: "Tiktok",
  qq: "QQ",
  twitter: "Twitter",
  viber: "Viber",
  future1: "Future1",
  future2: "Future2",
  future3: "Future3",
  login_log: "Login Log",
  failed: "Failed",
  web: "Web",
  mobile: "Mobile",
  platform: "Platform",
  bank_statement: "Bank Statement",
  transfer_date: "Transfer Date",
  detail: "Detail",
  date: "Date",
  transfer_list: "Transfer List",
  credit: "Credit",
  debit: "Debit",
  month: "Month",
  unblock: "Unblock",
  unblock_member: "Unblock Member",
  unblock_operator: "Unblock Operator",
  after_balance: "After Balance",
  referrer_id: "Referrer ID",
  referrer_code: "Referrer Code",
  referral_code: "Referral Code",
  bonus_and_adjustment: "Bonus & Adjustment",
  adjustment: "Adjustment",
  incoming_amount_threshold: "Incoming Amount Threshold",
  incoming_frequency_threshold: "Incoming Frequency Threshold",
  outgoing_amount_threshold: "Outgoing Amount Threshold",
  outgoing_frequency_threshold: "Outgoing Frequency Threshold",
  settle: "Settle",
  knock_off_by: "Knock Off By",
  knock_off_date: "Knock Off Date",
  accumulate_amount: "Accumulate Amount",
  deposit_amount: "Deposit Amount",
  total_turnover: "Total Turnover",
  total_winlose: "Total Winlose",
  total_deposit: "Total Deposit",
  total_withdrawal: "Total Withdrawal",
  total_member: "Total Member",
  active_player: "Active Player",
  top_winner: "Top Winner",
  top_loser: "Top Loser",
  winner: "Winner",
  loser: "Loser",
  deposit_count: "Deposit Count",
  withdrawal_count: "Withdrawal Count",
  bet_count: "Bet Count",
  summary: "Summary",
  alert: "Alert",
  incoming_threshold: "Incoming Threshold",
  incoming_frequency: "Incoming Frequency",
  outgoing_threshold: "Outgoing Threshold",
  outgoing_frequency: "Outgoing Frequency",
  reset_password: "Reset Password",
  authority_option: "Authority Option",
  transfer: "Transfer",
  company_bank: "Company Bank",
  company_bank_acc_no: "Company Bank Acc No.",
  company_bank_acc_holder: "Company Bank Acc Holder",
  registered_member: "Registered Member",
  registered_member: "Registered Member",
  promotion_report: "Promotion Report",
  deposited_member: "Deposited Member",
  referred_member: "Referred Member",
  validated_on: "Validated On",
  referrer: "Referrer",
  issue_livestream_bonus: "Issue Livestream Bonus",
  livestream_bonus: "Livestream Bonus",
  first_deposit: "First Deposit",
  first_deposit_at: "First Deposit At",
  nickname: "Nickname",
  member_nickname: "Member Nickname",
  free_spin: "Free Spin",
  reward: "Reward",
  in_game: "In Game",
  inbox: "Inbox",
  manual_bonus: "Manual Bonus",
  review: "Review | Reviews",
  review_list: "Review List",
  review_detail: "Review Detail",
  reply_review: "Reply Review",
  comment: "Comment",
  reply: "Reply",
  recipient_no: "Recipient No.",
  question : "Question",
  rating: "Rating",
  message: "Message",
  message_blast: "Message Blast",
  text: "Text",
  content: "Content",
  image: "Image",
  send: "Send",
  monthly_rating: "Monthly Rating",
  affiliate: "Affiliate",
  affiliate_list: "Affiliate List",
  approve_affiliate: "Approve Affiliate",
  affiliate_code: "Affiliate Code",
  approved_by: "Approved By",
  approved_date: "Approved Date",
  bank_affiliate: "Bank Affiliate",
  bank_id: "Bank ID",
  ticket_affiliate: "Ticket Affiliate",
  ticket_detail_affiliate: "Ticket Detail Affiliate",
  pending_application: "Pending Application",
  withdrawal_request: "Withdrawal Request",
  unblock_affiliate: "Unblock Affiliate",
  check_free_spin: "Check Free Spin",
  member_contribution: "Member Contribution",
  wallet_adjust: "Wallet Adjust",
  comm_package: "Comm Package",
  affiliate_id: "Affiliate ID",
  update_comm_package: "Update Comm Package",
  sub_account_detail: "Sub Account Detail",
  comm_log: "Comm Log",
  earning_breakdown: "Earning Breakdown",
  daily_winlose_member: "Daily Winlose Member",
  total_revenue: "Total Revenue",
  earning_amount: "Earning Amount",
  player_id: "Player ID",
  daily_winlose_affiliate: "Daily Winlose (Affiliate)",
  comm_package_old: "Old Comm Package",
  comm_package_new: "New Comm Package",
  export_excel: "Export Excel",
  get_tac: "Get TAC",
  tac_code: "TAC Code",
  expiry_date: "Expiry Date",
  inactive: "Inactive",
  player_list: "Player List",
  last_deposit_date: "Last Deposit Date",
  last_deposit_amount: "Last Deposit Amount",
  never_deposited: "Never Deposited",
  coupon: "Coupon",
  allocated: "Allocated",
  claimed: "Claimed",
  approved: "Approved",
  min_deposit: "Min Deposit",
  bonus_rate: "Bonus Rate",
  coupon_code: "Coupon Code",
  coupon_name: "Coupon Name",
  coupon_quota: "Coupon Quota",
  current_allocated: "Current Allocated",
  new_allocated: "New Allocated",
  update : "Update",
  coupon_own_status: "Coupon Own Status",
  tac_validated: "TAC Validated",
  copy: "Copy",
  deposit_amount: "Deposit Amount",
  bonus_rate_percent : "Bonus Rate (%)",
  coupon_desc: "Coupon Description",
  both: "Both",
  issue_free_spin: "Issue Free Spin",
  game: "Game",
  free_spin_count: "Free Spin Count",
  max_win_amount: "Max Win Amount",
  utm_list: "UTM List",
  search_by_member: "Search By Member",
  source: "Source",
  medium: "Medium",
  campaign: "Campaign",
  term: "Term",
  youtube: "YouTube",
  livechat: "LiveChat",
  deposited: "Deposited",
  search_by_id: "Search By ID",
  get_bank_tac: "Get Bank TAC",
  bank_statement_daily: "Bank Statement (Daily)",
  transfer_type: "Transfer Type",
  issue_jackpot_scratch: "Issue Jackpot Scratch",
  quantity: "Quantity",
  audit_freebies_list: "Audit Freebies List",
  acknowledge: "Acknowledge",
  submit_acknowledgement: "Submit Acknowledgement",
  blog: "Blog",
  is_ack: "Is Ack",
  yes: "Yes",
  no: "No",
  audit_rescue_fund_list: "Audit Rescue Fund List",
  issue_angpao: "Issue Angpao",
  global_setting: "Global Setting",
  signup_ip: "Signup IP",
  last_login_ip: "Last Login IP",
  last_login_time: "Last Login Time",
  link: "Link",
  is_default: "Is Default",
  is_public: "Is Public",
  bank_group: "Bank Group",
  set_default: "Set Default",
  group_id: "Group ID",
  group_name: "Group Name",
  provider_maintenance: "Provider Maintenance",
  provider_code: "Provider Code",
  provider_name: "Provider Name",
  withdrawal_limit: "Withdrawal Limit",
  limit_id: "Limit ID",
  limit_name: "Limit Name",
  daily_amount: "Daily Amount",
  daily_frequency: "Daily Frequency",
  promotion_id: "Promotion ID",
  promotion_name: "Promotion Name",
  withhold_bonus: "Withhold Bonus",
  withhold_amount: "Withhold Amount",
  withhold_amt: "Withhold Amt",
  max_withdraw_amt: "Max Withdraw Amt",
  max_withdraw_amount: "Max Withdraw Amount",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  start_time: "Start Time",
  end_time: "End Time",
  day: "Day | Days",
  coupon_status: "Coupon Status",
  campaign_id: "Campaign ID",
  campaign_name: "Campaign Name",
  prerequisite_promo_id: "Prerequisite Promo ID",
  promotion_group: "Promotion Group",
  referral_status: "Referral Status",
  referee_count_confirm: "Referee Count Confirm",
  referee_list: "Referee List",
  account_verified: "Account Verified",
  verified_date: "Verified Date",
  ticket_list: "Ticket List",
  pending_ticket: "Pending Ticket",
  reapprove: "Reapprove",
  vip_id: "Vip ID",
  vip_name: "Vip Name",
  self_rebate_rate: "Self Rebate Rate",
  downline_rebate_rate: "Downline Rebate Rate",
  provider: "Provider",
  mini_game: "Mini Game",
  team_log: "Team Log",
  result_log: "Result Log",
  match_id: "Match ID",
  home_team: "Home Team",
  away_team: "Away Team",
  home_team_new: "Home Team New",
  away_team_new: "Away Team New",
  updated_by: "Updated By",
  updated_on: "Updated On",
  home_score: "Home Score",
  away_score: "Away Score",
  home_score_new: "Home Score New",
  away_score_new: "Away Score New",
  team: "Team",
  match_time: "Match Time",
  match_round: "Match Round",
  home_group: "Home Group",
  away_group: "Away Group",
  match: "Match",
  match_status: "Match Status",
  insert: "Insert",
  pin: "Pin",
  bet_list: "Bet List",
  result_list: "Result List",
  bet_id: "Bet ID",
  bet_home: "Bet Home",
  bet_away: "Bet Away",
  bet_on: "Bet On",
  max_withdrawal: "Max Withdrawal",
  max_withdrawal_count: "Max Withdrawal Count",
  min_balance: "Min Balance",
  min_deposit: "Min Deposit",
  min_withdrawal: "Min Withdrawal",
  raise_deposit_ticket: "Raise Deposit Ticket",
  method: "Method",
  one_time_depositor: "One Time Depositor",
  current_month_non_depositor: "Current Month Non Depositor",
  ticket_date: "Ticket Date",
  ftd_amount: "FTD Amt",
  bonus_issue: "Bonus Issue",
  promotion_summary: "Promotion Summary",
  claim_frequency: "Claim Frequency",
  provider_list: "Provider List",
  platform_winlose: "Platform Winlose",
  adjustment_amount: "Adjustment Amount",
  referee_count: "Referee Count",
  category: 'Category',
  update_vip: "Update VIP",
  update_member_profile: "Update Member Profile",
  promotion_signup: "Promotion Signup",
  provider_bet_limit: "Provider Bet Limit",
  update_bet_limit: "Update Bet Limit",
  update_member_bet_limit: "Update Member Bet Limit",
  bet_limit: "Bet Limit",
  sports_game: "Sports/Game",
  match_time: "Match Time",
  league_name: "League Name",
  home_team_name: "Home Team Name",
  away_team_name: "Away Team Name",
  home_score: "Home Score",
  away_score: "Away Score",
  wl_status: "Winlose Status",
  available_bank_account: "Available Bank Account",
  group_bank_account: "Group Bank Account",
  edit_bank_group: "Edit Bank Group",
  edit_bank_account_group: "Edit Bank Account Group",
  redeposit: "Redeposit",
  upline: "Upline",
  downline: "Downline",
  available_promotion: "Available Promotion",
  group_promotion: "Group Promotion",
  edit_promotion_group_norm: "Edit Promotion Group Norm",
  balance_before: "Balance Before",
  balance_after: "Balance After",
  signup_count: "Signup Count",
  verified_count: "Verified Count",
  active_member: "Active Member",
  ftd_count: "FTD Count",
  daily_summary_company: "Daily Summary (Company)",
  daily_summary_member: "Daily Summary (Member)",
  adjustment_list: "Adjustment List",
  bonus_list: "Bonus List",
  ltd_date: "LTD Date",
  promotion_signup_unused: "Promotion Signup Unused",
  promotion_signup_ongoing: "Promotion Signup Ongoing",
  adjustment_log: "Adjustment Log",
  get_inbox: "Get Inbox",
  is_claimed: "Is Claimed",
  mix_parlay: "Mix Parlay",
  event: "Event",
  result_changes_log: "Result Changes Log",
  view_detail: "View Detail",
  total_referee: "Total Referee",
  verified_signup: "Verified / Signup",
  ftd: "FTD",
  raw_msg: "Raw Message",
  unselect_all: "Unselect All",
  select_all: "Select All",
  edit_bet_limit: "Edit Bet Limit",
  provider_game_off: "Provider Game Off",
  game_id : "Game ID",
  game_list: "Game List",
  off_list: "Off List",
  provider_rtp: "Provider RTP",
  rtp: "RTP",
  signup_date: "Signup Date",
  free_credit: "Free Credit",
  get_rebate: "Get Rebate",
  downline_rebate: "Downline Rebate",
  game_rebate: "Game Rebate",
  rebate: "Rebate",
  ftd_date: "FTD Date",
  provider_winlose_company: "Provider Winlose (Company)",
  report_promotion: "Report (Promotion)",
  already_hit: "Already Hit",
  ongoing: "Ongoing",
  members_export: "Member (Export)",
  get_recent_deposit: "Get Recent Deposit",
  recent_deposit: "Recent Deposit",
  survey_list: "Survey List",
  modified_on: "Modified On",
  game_balance: "Game Balance",
  outstanding_balance: "Outstanding Balance",
  last_update_time: "Last Update Time",
  last_validated: "Last Validated",
  trace: "Trace",
  trace_outstanding: "Trace Outstanding",
  outstanding: "Outstanding",
  clear_outstanding: "Clear Outstanding",
  current_month_no_login: "Current Month No Login",
  login_date: "Login Date",
  ftd_amount_min: "Min. FTD Amount",
  ftd_amount_max: "Max. FTD Amount",
  manual_bonus_only: "Manual Bonus Only",
  settled_time: "Settled Time",
  fl_provider_code: "First Launch Provider",
  fl_game_id: "First Launch Game ID",
  fl_game_name: "First Launch Game Name",
  no_deposit: "No Deposit",
  no_login: "No Login",
  top_deposit: "Top Deposit",
  top_withdrawal: "Top Withdrawal",
  top_rebate_self: "Top Rebate (Self)",
  top_rebate_downline: "Top Rebate (Downline)",
  top_promotion: "Top Promotion",
  signup_bonus: "Signup Bonus",
  sequence: "Sequence",
  edit_promotion_group_norm_seq: "Manage Promotion Sequence In Group",
  channel: "Channel",
  influencer: "Influencer",
  edit_campaign_provider_list: "Edit Campaign Provider List",
  max_withdraw_multiple: "Max Witdraw Multiple",
  mini_game_token_issue: "Mini Game Token Issue",
  token_available: "Token Available",
  with_prize: "With Prize",
  prize_amount: "Prize Amount",
  prize_list: "Prize List",
  mini_game_prize_report: "Mini Game Prize Report",
  prize: "Prize",
  count: "Count",
  total: "Total",
  used_on: "Used On",
  token: "Token",
  deposited_member_cny: "Deposited Member (CNY)",
  member_mission: "Member Mission",
  member_mission_summary: "Member Mission Summary",
  settlement_date: "Settlement Date",
  bonus_earned: "Bonus Earned",
  knock_off_reason: "Knock Off Reason",
  round_id: "Round ID",
  unfinish_round: "Unfinish Round",
  ticket_export: "Ticket (Export)",
  export_deposit: "Export Deposit",
  export_withdrawal: "Export Withdrawal",
  member_list: "Member List",
  member_details: "Member Details",
  member_info: "Member Info",
  ip_info: "IP Info",
  statement_info: "Statement Info",
  progress: "Progress",
  slots: "Slots",
  livecasino: "Livecasino",
  sportsbook: "Sportsbook",
  ticket_id: "Ticket ID",
  payment_gateway: "Payment Gateway",
  edit_promotion_group: "Edit Promotion Group",
  operator: "Operator",
  promotion_withdrawal_summary: "Promotion Withdrawal Summary",
  unique_player: "Unique Player",
  bet_value: "Bet Value",
  line_bet: "Line Bet",
  total_round: "Total Round",
  expiry_interval_days: "Expiry Interval (Days)",
  freespin_log: "Freespin Log",
  request_data: "Request_data",
  view_freespin_log_detail: "View Freespin Log Detail",
  exchange_rate: "Exchange Rate",
  rate: "Rate",
  rate_myr: "Rate MYR",
  log_repulling: "Log Repulling",
  one_api: "ONE Api",
  lines: "Lines",
  days: "Days",
  cms: "CMS",
  announcement_banner: "Announcement Banner",
  promotion_banner: "Promotion Banner",
  slide_banner: "Slide Banner",
  seo_page: "SEO Page",

  en_title: "Title (EN)",
  mys_title: "Title (MYS)",
  cn_title: "Title (CN)",
  en_img: "Image (EN)",
  mys_img: "Image (MYS)",
  cn_img: "Image (CN)",
  en_body: "Body (EN)",
  mys_body: "Body (MYS)",
  cn_body: "Body (CN)",
  before_login: "Before Login",
  after_login: "After Login",
  en: "EN",
  mys: "MYS",
  cn: "CN",
  move_up: "Move Up",
  move_down: "Move Down",
  banner_type: "Banner Type",
  default_order: "Default Order",
  item_order: "Item Order",
  title: "Title",
  banner_id: "Banner ID",
  order: "Order",
  body: "Body",
  en_image: "Image (EN)",
  mys_image: "Image (MYS)",
  cn_image: "Image (CN)",
  move: "Move",
  en_img_desktop: "Img Desktop (EN)",
  mys_img_desktop: "Img Desktop (MYS)",
  cn_img_desktop: "Img Desktop (CN)",
  en_img_mobile: "Img Mobile (EN)",
  mys_img_mobile: "Img Mobile (MYS)",
  cn_img_mobile: "Img Mobile (CN)",
  login_required: "Login Required",
  new_window_tab: "New Window / Tab",
  current_page: "Current Page",
  target: "Target",
  alt: "Alt",
  href: "Href",
  image_desktop: "Desktop Image",
  image_mobile: "Mobile Image",
  en_alt: "Alt (EN)",
  mys_alt: "Alt (MYS)",
  cn_alt: "Alt (CN)",
  en_href: "Href (EN)",
  mys_href: "Href (MYS)",
  cn_href: "Href (CN)",
  en_image_desktop: "Desktop Image (EN)",
  mys_image_desktop: "Desktop Image (MYS)",
  cn_image_desktop: "Desktop Image (CN)",
  active_period: "Active Period",
  en_page: "Page (EN)",
  mys_page: "Page (MYS)",
  cn_page: "Page (CN)",
  en_item: "Item (EN)",
  mys_item: "Item (MYS)",
  cn_item: "Item (CN)",
  meta_title: "Meta Title",
  meta_keywords: "Meta Keywords",
  meta_url: "Meta URL",
  meta_canonical: "Meta Canonical",
  meta_author: "Meta Author",
  meta_publisher: "Meta Publisher",
  meta_lang: "Meta Lang",
  meta_desc: "Meta Desc",
  meta_image: "Meta Image",
  page: "Page",
  item: "Item",
  remove_desktop_image: "Remove Desktop Image",
  remove_mobile_image: "Remove Mobile Image",
  page_name: "Page Name",
  btn_href: "Button Href",
  btn_text: "Button Text",
  meta_image_url: "Meta Image Url",

  news: "News",
  preview_body: "Preview Body",
  full_body: "Full Body",
  slug: "Slug",
  domain: "Domain",
  preview: "Preview",
  preview1: "Preview 1",
  preview2: "Preview 2",
  preview3: "Preview 3",

  auto_withdrawal: "Auto Withdrawal",
  submit_pg: "Submit Payment Gateway",
  rejected_ticket_id: "Rejected Ticket Id",
  resubmit: "Resubmit",
  processing: "Processing",
  gateway_user_code: "Gateway User Code",
}

